/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationPolicyPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyPageResponseOutputItemsItemTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyPageResponseOutputItemsItemTeamNameMax = 120;

export const notificationPolicyPageResponseOutputItemsItemNameMax = 120;

export const notificationPolicyPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const notificationPolicyPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const notificationPolicyPageResponseOutputItemsItemStepCountExclusiveMin = 0;
export const notificationPolicyPageResponseOutputItemsItemStepCountMax = 9007199254740991;

export const notificationPolicyPageResponseOutputItemsItemMinDelayMinutesMin = 0;
export const notificationPolicyPageResponseOutputItemsItemMinDelayMinutesMax = 1440;

export const notificationPolicyPageResponseOutputItemsItemMaxDelayMinutesMin = 0;
export const notificationPolicyPageResponseOutputItemsItemMaxDelayMinutesMax = 1440;

export const notificationPolicyPageResponseOutputItemsItemLastUsedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const notificationPolicyPageResponseOutputItemsMax = 100;

export const notificationPolicyPageResponseOutputNextCursorOneMax = 2000;

export const NotificationPolicyPageResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(notificationPolicyPageResponseOutputItemsItemIdRegExp),
        team: zod.object({
          id: zod.uuid().regex(notificationPolicyPageResponseOutputItemsItemTeamIdRegExp),
          name: zod.string().min(1).max(notificationPolicyPageResponseOutputItemsItemTeamNameMax),
        }),
        name: zod.string().min(1).max(notificationPolicyPageResponseOutputItemsItemNameMax),
        version: zod
          .int()
          .gt(notificationPolicyPageResponseOutputItemsItemVersionExclusiveMin)
          .max(notificationPolicyPageResponseOutputItemsItemVersionMax),
        enabled: zod.boolean(),
        stepCount: zod
          .int()
          .gt(notificationPolicyPageResponseOutputItemsItemStepCountExclusiveMin)
          .max(notificationPolicyPageResponseOutputItemsItemStepCountMax),
        minDelayMinutes: zod
          .int()
          .min(notificationPolicyPageResponseOutputItemsItemMinDelayMinutesMin)
          .max(notificationPolicyPageResponseOutputItemsItemMinDelayMinutesMax),
        maxDelayMinutes: zod
          .int()
          .min(notificationPolicyPageResponseOutputItemsItemMaxDelayMinutesMin)
          .max(notificationPolicyPageResponseOutputItemsItemMaxDelayMinutesMax),
        lastUsedAt: zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(notificationPolicyPageResponseOutputItemsItemLastUsedAtOneRegExp),
          zod.null(),
        ]),
      }),
    )
    .max(notificationPolicyPageResponseOutputItemsMax),
  nextCursor: zod.union([
    zod.string().max(notificationPolicyPageResponseOutputNextCursorOneMax),
    zod.null(),
  ]),
});

export type NotificationPolicyPageResponseOutput = zod.input<
  typeof NotificationPolicyPageResponseOutput
>;
export type NotificationPolicyPageResponseOutputOutput = zod.output<
  typeof NotificationPolicyPageResponseOutput
>;
